import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser, selectIsAdmin, selectCompanyName } from "../../store/slices/authSlice";
import "./Layout.css";
import { BsBell } from "react-icons/bs";
import { IoIosArrowDown } from "react-icons/io";
import headeravatar from "../../assets/images/header-avatar.png";

export default function Navbar() {
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);
  const isAdmin = useSelector(selectIsAdmin);
  const companyName = useSelector(selectCompanyName);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    navigate("/logout");
  };

  const handleSettings = () => {
    navigate("/settings");
    setShowDropdown(false);
  };

  const handleAdminPanel = () => {
    navigate("/admin/dashboard");
    setShowDropdown(false);
  };

  const userName = user
    ? `${user.firstName} ${user.lastName}`
    : "Guest User";
  const userEmail = user?.email || "guest@example.com";

  return (
    <header className="topbar">
      <div className="topbar-inner">
        <div className="search">
          <input type="text" placeholder="Search" />
        </div>

        <div className="user-info">
          <img className="header-avatar" src={headeravatar} alt="User Avatar" />

          <div className="user-text">
            <div className="hello">
              Hello, <strong>{userName}</strong>
            </div>
            <div className="email">{userEmail}</div>
            {companyName && (
              <div className="company-name">{companyName}</div>
            )}
          </div>

          <div className="navbar-dropdown-wrapper" ref={dropdownRef}>
            <span
              className="dropdown"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              <IoIosArrowDown size={24} />
            </span>

            {showDropdown && (
              <div className="navbar-dropdown-menu">
                <button onClick={handleSettings} className="dropdown-item">
                  Settings
                </button>
                {isAdmin && (
                  <button onClick={handleAdminPanel} className="dropdown-item">
                    Admin Panel
                  </button>
                )}
                <div className="dropdown-divider"></div>
                <button onClick={handleLogout} className="dropdown-item danger">
                  Logout
                </button>
              </div>
            )}
          </div>

          <span className="bell">
            <BsBell size={24} />
          </span>
        </div>
      </div>
    </header>
  );
}
